<template>
    <div v-if="!isLoading" class="requestRatingPg">
        <div class="logoSec row justify-content-between align-items-center">
            <div class="col-lg-2 col-xl-2 col-5 p-0">
                <a>
                    <img src="../../assets/images/mhh-logo.svg" alt="Logo" class="img-fluid" />
                </a>
            </div>
            <div v-if="config.is_from_inside" class="col-12 col-lg-4 col-xl-3 consumerrating-techname">
                <h4>{{ config.job_details.company_name }}</h4>
                <p class="mb-0">Technician: <span>{{ config.job_details.technician_name }}</span></p>
            </div>

        </div>
        <div class="consumerrating-detail row my-4">
            <div class="col-lg-4 col-12">
                <span>
                    Job Number:
                </span>
                <p class="m-0">{{ config.job_details.job_number }}</p>
            </div>
            <div class="col-lg-5 col-12">
                <span>
                    Service Address:
                </span>
                <p class="m-0">{{ config.job_details.service_address }}</p>
            </div>
            <div class="col-lg-3 col-12">
                <span>
                    Customer Name:
                </span>
                <p class="m-0">{{ config.job_details.consumer_name }}</p>
            </div>
        </div>
        <div class="reviewReqHead row align-items-center">
            <div class="col-12 col-lg-8 col-md-6 p-0">
                <h4 class="mb-0 fw-bold">Your opinion matters! Share your thoughts on your <span>{{ work_order_details.trade_name }} {{
                            work_order_details.service_name }} {{
                            work_order_details.component_name }}</span>.</h4>
            </div>
            <div class="col-12 col-lg-4 col-md-6 p-0 flex align-items-center mobile:justify-start tablet:justify-end">
                <div class="flex mobile:items-start tablet:items-end flex-col text-right">
                    <img src="../../assets/images/ratingsIcon.png" alt="Rating Icon" class="ratingStrip">
                    <p class="mb-0 mt-2">1 being very dissatisfied, 5 being very satisfied</p>
                </div>
            </div>
        </div>
        <div class="allReviews">
            <div :class="isSubmit && review.rating_value <= 0 ? 'reviewDescription error' : 'reviewDescription'"
                v-for="(review, index) in ratings" :key="index">
                <div class="row align-items-center">
                    <div class="col-lg-9 col-md-7">
                        <div class="reviewDesDetail">
                            <div class="reviewIcon">
                                <img src="../../assets/images/big-star-icon.png" alt="Star Icon" class="img-fluid" />
                            </div>
                            <div class="reviewDetail">
                                <h6 class="mb-0">{{ review.item_name }}</h6>
                                <p class="mb-0">{{ review.item_description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-5">
                        <div class="reviewRating">
                            <div class="rating-container">
                                <div v-if="!alreadySubmitted" class="slider-container">
                                    <input :disabled="alreadySubmitted" type="range" min="1" max="5"
                                        v-model="review.rating_value" class="slider"
                                        :class="{ active: review.interacted }"
                                        :style="review.interacted ? sliderBackground(review.rating_value) : ''"
                                        @mousedown="handleInteraction(index)" @touchstart="handleInteraction(index)"
                                        @input="handleInteraction(index, true)" />
                                </div>
                                <div v-else class="slider-container">
                                    <input :disabled="alreadySubmitted" type="range" min="1" max="5"
                                        v-model="review.rating_value" class="slider" :class="{ active: true }"
                                        :style=sliderBackground(review.rating_value) />
                                </div>
                                <div class="stars d-flex justify-content-between">
                                    <div v-for="star in 5" :key="star" class="star-item"
                                        @click="setRating(index, star)">
                                        <span class="star" :class="{ active: star <= review.rating_value }">
                                            <i class="fa fa-star"></i>
                                        </span>
                                        <span class="number">{{ star }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span v-if="isSubmit && review.rating_value <= 0" class="errorMessage">This field is required.</span>
            </div>
        </div>
        <div class="recommendation error">
            <label class="question mb-0">Would you recommend our services to others?</label>
            <div class="toggle d-flex">
                <label class="mb-0" :class="['option', (recommendedValue == 0) ? 'active' : '']">
                    <input :disabled="alreadySubmitted" type="radio" :value=0 v-model="recommendedValue" />
                    No
                </label>
                <label class="mb-0" :class="['option', recommendedValue == 1 ? 'active' : '']">
                    <input :disabled="alreadySubmitted" type="radio" :value=1 v-model="recommendedValue" />
                    Yes
                </label>
            </div>
            <span v-if="isSubmit && recommendedValue < 0" class="errorMessage">This field is required.</span>

        </div>
        <div class="feedbackSec">
            <h6 class="mb-2">Please provide any feedback or suggestions that could help us improve our service.</h6>
            <textarea :disabled="alreadySubmitted" v-model="feedback" name="" id="" rows="5" maxlength="500"></textarea>
        </div>
        <div v-if="!alreadySubmitted" class="reviewBottomButtons">
            <button @click="submitReview" class="submitButton">Submit</button>
        </div>
        <div class="reviewFooter text-center">
            <p class="mb-0">Thank you for choosing MyHappyHome We appreciate the opportunity to work with you.</p>
            <a href="https://www.myhappyhome.com">www.myhappyhome.com</a>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: 'StarRating',
    watch: {
        recommendedValue(newValue, oldValue) {
            //    this.isSubmit = false
        },

        ratingReviewConfigResponse : function (data) {
            this.config = this.ratingReviewConfigResponse
            this.work_order_details = this.config.work_order_details
            this.ratings = this.config.questions
            this.recommendedValue = this.config.is_service_recommended
            if ((this.recommendedValue != 0 && this.recommendedValue != 1) || this.recommendedValue.length <= 0) {
                this.recommendedValue = -1
            }
            this.feedback = this.config.feedback_description
            this.alreadySubmitted = this.config.already_submitted ?? 0

            if (this.alreadySubmitted) {
                this.alreadySubmitted = true
            }
            else {
                this.alreadySubmitted = false
            }
            this.isLoading = false  
        },

        ratingReviewResponse: function (data) {
            this.alreadySubmitted = true
            let google_rating_url = this.ratingReviewResponse.google_rating_url
            if (google_rating_url.length > 0) {
                window.location.href = google_rating_url;
            }
            this.getConfig()
        }
    },

    computed: {
        ...mapGetters([
            "ratingReviewConfigResponse",
            "ratingReviewResponse"
        ])
    },

    data() {
        return {
            isSubmit: false,
            isLoading: true,
            config: {},
            ratings: [],
            recommendedValue: -1,
            feedback: '',
            alreadySubmitted: 0,
            params: this.$route.query.params ?? '',
            work_order_details: {}
        };
    },

    mounted() {
        this.getConfig()
    },
    methods: {
        ...mapActions([
            "getRatingReviewConfig",
            "postRatingReview"
        ]),
        getConfig() {
            this.isLoading = true
            this.getRatingReviewConfig({
                'params': this.params
            })

        },
        setRating(index, value) {
            // this.isSubmit = false
            if (!this.alreadySubmitted) {
                this.ratings[index].rating_value = value;
                this.ratings[index].interacted = true;
            }

        },
        sliderBackground(value) {
            const percent = ((value - 1) / 4) * 100;
            return `background: linear-gradient(to right, #2459a8 ${percent}%, #ccc ${percent}%);`;
        },
        handleInteraction(index, isInput = false) {

            //  this.isSubmit = false
            const review = this.ratings[index];
            if (!review.interacted) {
                review.interacted = true;
                if (!isInput && review.rating_value === 0) {
                    review.rating_value = 1;
                }
            }
        },
        getReviewPayload() {
            return {
                questions: this.ratings.map(review => ({
                    template_id: review.template_id,
                    rating_value: review.rating_value,
                })),
                is_service_recommended: this.recommendedValue,
                feedback_description: this.feedback,
                params: this.params
            };
        },

        isValid() {
            let status = true
            for (let idx in this.config.questions) {
                let obj = this.config.questions[idx]
                let rValue = obj.rating_value
                if (rValue == 0) {
                    status = false
                    break
                }
            }
            if (this.recommendedValue < 0) {
                status = false
            }
            return status
        },

        submitReview() {
            this.isSubmit = true
            if (this.isValid()) {
                //   this.isSubmit = false
                const payload = this.getReviewPayload();
                this.postRatingReview(payload)
            }
        }
    },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
@media only screen and (max-width: 991px) {
    .consumerrating-techname {
        padding: 30px 0px 0px !important;
    }

    .consumerrating-detail {
        gap: 10px;
    }
}

.logoSec.row.justify-content-between.align-items-center {
    margin: 0 auto;
}

.consumerrating-techname h4 {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    margin-bottom: 0px;
    font-family: "Roboto", sans-serif;
    border-bottom: 1px solid #CCCCCC;
    padding-bottom: 7px;
    line-height: 1.1;
}

.consumerrating-techname p {
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    padding-top: 7px;
}

.consumerrating-techname p span {
    font-weight: 500;
    font-size: 18px;
    color: #2459a8;
    font-family: "Roboto", sans-serif;
}

.consumerrating-detail {
    padding: 15px 0px;
    border: 1px solid #EFEFEF;
    border-radius: 10px;
    margin: 0 auto;
    font-family: "Roboto", sans-serif;
}

.consumerrating-detail p {
    font-weight: 500;
    font-size: 20px;
    color: #666666;
}

.consumerrating-detail span {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}

.requestRatingPg {
    padding: 2rem 5rem;
}

.reviewReqHead {
    box-shadow: 0px 0px 10px 0px #0000001A;
    padding: 1rem;
    border-radius: 10px;
    margin: 2rem 0;
}

.reviewReqHead h4 {
    color: #666;
    font-weight: 500;
    font-size: 22px;
}

.reviewReqHead h4 span {
    color: #2459a8;
    font-size: 22px;
}

.requestRatingPg .ratingStrip {
    width: 150px;
}

.requestRatingPg .allReviews {
    display: grid;
    gap: 20px;
}

.requestRatingPg .reviewDescription {
    position: relative;
    box-shadow: 0px 0px 10px 0px #0000001A;
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid transparent;
    position: relative;
}

.error {
    border: 1px solid #f5b134 !important;
}

.errorMessage {
    color: #f5b134;
    padding: 0.2rem 1rem;
    font-size: 14px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10196);
    border-radius: 50px;
    position: absolute;
    bottom: -13px;
    left: 90px;
    background: #fff;
}

.requestRatingPg .reviewDesDetail {
    display: flex;
    align-items: center;
    gap: 15px;
}

.requestRatingPg .reviewDescription .reviewDesDetail .reviewIcon {
    box-shadow: 0px 0px 10px 0px #0000001A;
    background-color: #fff;
    border-radius: 50%;
    min-width: 70px;
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.requestRatingPg .reviewDescription .reviewDesDetail .reviewIcon img {
    width: 40px;
    height: 40px;
}

.requestRatingPg .reviewDescription .reviewDesDetail .reviewDetail h6 {
    font-size: 20px;
    color: #2459a8;
}

.requestRatingPg .reviewDescription .reviewDesDetail .reviewDetail p {
    font-size: 18px;
    color: #666;
}

.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 6px;
    background: #ccc;
    border-radius: 4px;
    transition: background 0.3s ease;
    position: relative;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: radial-gradient(circle at center, #f5b134 3px, white 4px);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border: none;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.slider.active::-webkit-slider-thumb {
    opacity: 1;
}

.slider::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: radial-gradient(circle at center, #f5b134 3px, white 4px);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border: none;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.slider.active::-moz-range-thumb {
    opacity: 1;
}

.requestRatingPg .stars {
    margin-top: 1rem;
}

.requestRatingPg .star-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.requestRatingPg .star {
    font-size: 20px;
    color: #ccc;
    cursor: pointer;
    line-height: normal;
}

.requestRatingPg .star.active {
    color: #F3BA40;
}

.requestRatingPg .recommendation {
    display: flex;
    align-items: center;
    gap: 15px;
    font-family: sans-serif;
    margin: 2rem 0;
    position: relative;
}

.requestRatingPg .recommendation.error {
    border: 0 !important;
}

.requestRatingPg .recommendation .errorMessage {
    position: absolute;
    bottom: -20px;
    left: 0;
    box-shadow: none;
    padding: 0;
}

.requestRatingPg .recommendation .question {
    font-size: 18px;
    color: #333;
}

.requestRatingPg .recommendation .toggle {
    gap: 10px;
}

.requestRatingPg .recommendation .option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 12px;
    border-radius: 25px;
    font-size: 16px;
    cursor: pointer;
    color: #333;
    font-weight: 500;
    background: #E1E1E1;
    min-width: 80px;
    justify-content: center;
}

.requestRatingPg .recommendation .option input[type='radio'] {
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 0;
    background-color: white;
    position: relative;
}

.requestRatingPg .recommendation .option input[type='radio']:checked::before {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    background: #2459a8;
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 4px;
}

.requestRatingPg .recommendation .active {
    background-color: #2459a8;
    color: white;
}

.requestRatingPg .feedbackSec h6 {
    color: #2459a8;
    font-size: 18px;
}

.requestRatingPg .feedbackSec textarea {
    padding: 0.5rem;
    border-radius: 10px;
    border: 1px solid #CCCCCC;
    resize: none;
    width: 100%;
}

.requestRatingPg .reviewBottomButtons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 2rem;
}

.requestRatingPg .reviewBottomButtons button {
    font-size: 20px;
    background: transparent;
    color: #fff;
    border-radius: 10px;
    padding: 0.5rem 1.5rem;
    border: 0 !important;
}

.requestRatingPg .reviewBottomButtons button.cancelButton {
    background: #f5b134;
}

.requestRatingPg .reviewBottomButtons button.submitButton {
    background: #2459a8;
}

.requestRatingPg .reviewBottomButtons button.submitButton:focus {
    outline: none !important;
}

.reviewFooter {
    border-top: 2px solid #2459a8;
    padding-top: 1rem;
    margin-top: 3rem;
}

.reviewFooter p {
    font-size: 16px;
    color: #000;
}

.reviewFooter a {
    font-size: 16px;
    color: #2459a8;
}

.reviewRating .slider-container input:disabled {
    opacity: 1 !important;
}






@media only screen and (max-width: 1200px) {
    .requestRatingPg {
        padding: 2rem;
    }

    .requestRatingPg .star {
        font-size: 16px;
    }
}

@media only screen and (max-width: 1024px) {
    .requestRatingPg .reviewDescription .reviewDesDetail .reviewIcon img {
        width: 30px;
        height: 30px;
    }

    .requestRatingPg .reviewDescription .reviewDesDetail .reviewIcon {
        min-width: 60px;
        width: 60px;
        height: 60px;
    }
}

@media only screen and (max-width: 767px) {
    .reviewReqHead .text-right {
        text-align: left !important;
        margin-top: 20px !important;
    }

    .requestRatingPg .reviewReqHead .flex-row {
        text-align: left;
    }

    .requestRatingPg .reviewReqHead h4 {
        font-size: 20px;
    }

    .requestRatingPg .reviewReqHead p {
        margin: 0.5rem 0 1rem !important;
    }

    .requestRatingPg .reviewDesDetail {
        margin-bottom: 1rem;
    }

    .requestRatingPg .reviewDescription .reviewDesDetail .reviewDetail h6,
    .requestRatingPg .reviewDescription .reviewDesDetail .reviewDetail p {
        font-size: 16px;
    }
}

@media only screen and (max-width: 576px) {
    .requestRatingPg {
        padding: 1rem;
    }

    .requestRatingPg .logoSec .col-lg-2 {
        max-width: 50% !important;
    }



    .requestRatingPg .recommendation {
        display: block;
        position: relative;
    }


    .requestRatingPg .recommendation .question {
        font-size: 16px;
        display: block;
        text-align: center;
        margin-bottom: 0.5rem !important;
    }

    .requestRatingPg .recommendation .toggle {
        justify-content: center;
    }

    .requestRatingPg .reviewBottomButtons button {
        font-size: 16px;
    }
}
</style>